var globalModel;
var first=false;
var callingPopup = false;
var markedClean = false;

var flip = true;
ko.extenders.dirty = function (target, startDirty) {
    if (first == false) {
        first = true;
        globalModel = target;
        globalCleanValueJson = ko.observable(ko.toJSON(globalModel));
    }
    var cleanValue = ko.observable(ko.toJSON(target));
    var dirtyOverride = ko.observable(ko.utils.unwrapObservable(startDirty));
    target.isDirty = ko.computed(function () {
        /*
        globalCleanValue = cleanValue();
        globalTargetValue = ko.toJSON(target);
        console.log(dirtyOverride() || ko.toJSON(target) !== cleanValue())
        return dirtyOverride() || ko.toJSON(target) !== cleanValue();
        */
        
        globalCleanValue = globalCleanValueJson();
        globalTargetValue = ko.observable(ko.toJSON(globalModel))();
        //console.log(globalTargetValue)
        //console.log("Clean Value");
        //console.log(globalCleanValue)
        //console.log(globalTargetValue !== globalCleanValue)
        //console.log(dirtyOverride() || globalCleanValue !== globalTargetValue)
        return dirtyOverride() || globalCleanValue !== globalTargetValue;
        
        
    });

    target.isDirty.subscribe(function () {
        if (callingPopup == false) {
            callingPopup = true;
            var popup = $(".unsavedChanges");
            if (target.isDirty() && !popup.is(":visible")) {
                console.log("showing isdirty popup");
                //console.log(target());
                popup.removeClass("fadeOut");
                popup.animateCss('bounceIn');
                popup.toggleClass("inlineBlock", true);
                callingPopup = false;
                $(window).off('beforeunload');
            } else {
                if (popup.is(":visible")) {
                    console.log("hiding isdirty popup");
                    popup.removeClass("bounceIn");
                    popup.animateCss('fadeOut', function () {
                        popup.toggleClass("inlineBlock", false);
                    });
                    callingPopup = false;
                }

            }
        }
        
    });

    window.onbeforeunload = function () {
        var popup = $(".unsavedChanges");

        console.log(popup.is(":visible"))
        if (popup.is(":visible") && markedClean == false)
            return "popup";
        else {
            return null;
        }
    };

    target.markClean = function () {
        console.log("Marking Clean");
        markedClean = true;
        globalCleanValueJson(ko.toJSON(target));
        cleanValue(ko.toJSON(target));
        dirtyOverride(false);

    };
    target.markDirty = function () {
        dirtyOverride(true);
    };

    return target;
};

ko.bindingHandlers.stopBinding = {
    init: function () {
        return { controlsDescendantBindings: true };
    }
};

ko.bindingHandlers.bidirectionVisible = {
    init: function(element, valueAccessor) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutationRecord) {
                var value = valueAccessor();

                if (mutationRecord.target.style.display === "none") {
                    value(false);
                } else {
                    value(true);
                }
            });    
        });

        observer.observe(element, { attributes : true, attributeFilter : ['style'] });
    },
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        var isCurrentlyVisible = !(element.style.display === "none");
        if (value && !isCurrentlyVisible)
            element.style.display = "";
        else if ((!value) && isCurrentlyVisible)
            element.style.display = "none";
    }
};




